import { render, staticRenderFns } from "./ContactRequests.vue?vue&type=template&id=27d51bf8&scoped=true&"
import script from "./ContactRequests.vue?vue&type=script&lang=js&"
export * from "./ContactRequests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27d51bf8",
  null
  
)

export default component.exports